<template>
  <div>
    <ckeditor :editor="Editor" v-model="content" :config="editorConfig" :disabled="disabled" />
  </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  name: 'CkeditorWidget',
  components: {
    ckeditor: CKEditor.component
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      Editor: ClassicEditor,
      content: this.modelValue,
      editorConfig: {
        toolbar: [
          'heading', '|',
          'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
          'undo', 'redo'
        ]
      }
    };
  },
  watch: {
    content(val) {
      this.$emit('update:modelValue', val);
    },
    modelValue(val) {
      if (val !== this.content) {
        this.content = val;
      }
    }
  }
};
</script>